<script setup lang="ts">
import { useRouter } from 'vue-router';
import { AccountRouteName } from '@/js/account/app/router/route-names';
import BaseTitle from '@/js/account/components/base/BaseTitle.vue';
import CreateButton from '@/js/account/components/base/CreateButton.vue';
import LibraryDocumentsBrowse from '@/js/account/components/library/LibraryDocumentsBrowse.vue';
import ProfileHeader from '@/js/account/components/profile/ProfileHeader.vue';
import { useDocumentListBrowse } from '@/js/account/entities/document';
import { accountLibraryIndex } from '@/js/account/entities/document/api';
import { useAuth } from '@/js/account/entities/session';
import { classNames } from '@/js/lib/bem';

const cn = classNames('profile-library-page');

const router = useRouter();
const { isAdmin } = useAuth();

const {
  search,
  sortBy,
  filters,
  page,
  loading,
  list,
  error,
  perPage,
  onPageChange,
  reloadFromFirstPage,
  reload,
} = useDocumentListBrowse(accountLibraryIndex, { searchReturnsFullSet: true });

async function goToDocumentCreate(): Promise<void> {
  await router.push({ name: AccountRouteName.AdminDocumentCreate });
}
</script>

<template>
  <div :class="cn()">
    <ProfileHeader>
      <template #left>
        <BaseTitle size="md">
          Library
        </BaseTitle>
      </template>
      <template v-if="isAdmin" #right>
        <CreateButton label="Add document" @create="goToDocumentCreate" />
      </template>
    </ProfileHeader>

    <div :class="cn('content')">
      <LibraryDocumentsBrowse
        v-model:search="search"
        v-model:sort-by="sortBy"
        v-model:filters="filters"
        v-model:page="page"
        :list="list"
        :loading="loading"
        :error="error"
        :per-page="perPage"
        enable-search-results
        empty-message="No documents found."
        @reload-from-first-page="reloadFromFirstPage"
        @page-change="onPageChange"
        @reload="reload"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.profile-library-page {
  font-family: var(--font-family-sans);
  font-size: 24px;
  color: var(--color-text-primary);

  &__content {
    padding: 32px;
  }

  @media (max-width: 768px) {
    &__content {
      padding: 16px;
    }
  }
}
</style>
